import React, {ReactElement} from 'react';
import signInPageLogo from '@assets/images/medops/sign_in_page_logo.svg';
const SignInPageLogo = (props: any): ReactElement => {
  return <img src={signInPageLogo} {...props} />;
};
export default SignInPageLogo;
